exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#toolsViewerComponent{position:fixed;top:56px;z-index:1069;width:100%;padding:5px;background-color:#9f0303}#contextualizedTitleSpan,#tools{font-style:italic;font-size:14px}#icons,#toolbar{color:#fff}#toolbar{margin-left:10px}#searchInput{width:20em;margin-right:20px}.spacer{flex:1 1 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c1c3c08","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/commons/ToolsViewer.vue
// module id = 684
// module chunks = 0